import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { AgentActivityEventHydration } from './agent-activity-event-hydration.dto';

/**
 * An agent activity event with hydrated related records.
 */
export class AgentActivityEventDto extends ActivityEventDto {
  hydrated?: AgentActivityEventHydration;
}
